export type stagesType = "development" | "production";

export const STAGE: stagesType =
  (process.env.REACT_APP_STAGE as stagesType) || "development";

export const API_URL = process.env.REACT_APP_API_URL || "";

export const api = {
  allPools: 'api/table',
  userPools: 'api/table/user-table',
  userStatistics: 'api/table/user-statistics',
  allStatistics: 'api/table/statistics',
  sidebar: 'api/table/sidebar',
  tokenPrices :'api/tokens/tokens-prices'
};

export const BASE_URL = process.env.REACT_APP_BASE_URL || '';
